
import { createUseStyles, useTheme } from 'react-jss'
import { Outlet, useLocation } from 'react-router-dom'
import { Layout } from 'antd'
import { useToggle } from '../../hooks'

import Header from './Header'
import SideBar from './SideBar'
import { SidebarProvider } from './SidebarContext'
import Downloads from '../Downloads'
import OfficeCheckDownloads from '../OfficeCheckDownloads'
import PreAuthorizationDownloads from '../PreAuthorizationDownloads'
import PatientsExcel from '../PatientsExcel'

const { Content } = Layout

export default function AppLayout() {
  const theme = useTheme()
  const location = useLocation()

  const useStyles = createUseStyles({
    outer: {
      minHeight: '100vh',
      '& .ant-layout-sider': {
        minHeight: '100vh',
      },
    },
    content: {
      margin: '24px 16px',
      padding: 24,
      background: ({ theme: th }) => th.brandBackground,
      minHeight: 280,
    },
  })
  const classes = useStyles({ theme, location })


  const [isSidebarVisible, setIsSidebarVisible] = useToggle(true)

  return (
    <Layout className={classes.outer}>
      <SideBar collapsed={!isSidebarVisible} />
      <Layout>
        <Header
          collapsed={!isSidebarVisible}
          handleToggleCollapsed={setIsSidebarVisible}
          collapsedWidth={70}
        />
        <Content className={classes.content}>
          <SidebarProvider setIsSidebarVisible={setIsSidebarVisible} isSidebarVisible={isSidebarVisible}>
            <Outlet />
          </SidebarProvider>
        </Content>
        <Downloads />
        <OfficeCheckDownloads />
        <PreAuthorizationDownloads />
        <PatientsExcel />
      </Layout>
    </Layout>
  )
}
